// Enums
export enum TransactionType {
  Transfer = 'TRANSFER',
  Correction = 'CORRECTION',
  System = 'SYSTEM',
}

export enum TransactionStatus {
  InProgress = 'IN_PROGRESS',
  Finalized = 'FINALIZED',
}

export enum TransactionSource {
  Manual = 'MANUAL',
  Automatic = 'AUTOMATIC',
}

// Location info in transactions
export interface TransactionLocation {
  id: number;
  name: string;
  code: string;
}

// User info in transactions
export interface TransactionUser {
  id: number;
  name: string;
  email: string;
}

// Asset type info in transaction details
export interface TransactionAssetType {
  id: number;
  name: string;
  code: string;
}

// DTOs matching the GO API
export interface CreateTransactionDTO {
  type: TransactionType;
  toLocationId: number;
  fromLocationId: number;
  carrierId?: number;
  transactionDate?: string;
  documentNumber?: string;
  referenceNumber?: string;
  notes?: string;
  details: CreateTransactionDetailDTO[];
}

export interface CreateTransactionDetailDTO {
  assetTypeId?: number;
  assetId?: number;
  amount: number;
}

export interface UpdateTransactionDTO {
  type: TransactionType;
  status: TransactionStatus;
  toLocationId: number;
  fromLocationId: number;
  carrierId?: number;
  transactionDate?: string;
  documentNumber?: string;
  referenceNumber?: string;
  notes?: string;
  details: UpdateTransactionDetailDTO[];
}

export interface UpdateTransactionDetailDTO {
  assetTypeId?: number;
  assetId?: number;
  amount: number;
}

export interface GetTransactionDTO {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  transactionId: string;
  type: TransactionType;
  status: TransactionStatus;
  source: TransactionSource;
  toLocation: TransactionLocation;
  fromLocation: TransactionLocation;
  carrier?: TransactionLocation;
  transactionDate?: string;
  documentNumber?: string;
  referenceNumber?: string;
  notes?: string;
  details: GetTransactionDetailDTO[];
  createdBy?: TransactionUser;
}

export interface GetTransactionDetailDTO {
  id: number;
  assetType: TransactionAssetType;
  assetId?: number;
  amount: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

// Filter options for querying transactions
export interface TransactionFilterOptionsDTO {
  locationId?: number;
  assetTypeId?: number;
  searchText?: string;
  type?: TransactionType;
  status?: TransactionStatus;
  source?: TransactionSource;
  dateFrom?: string;
  dateTo?: string;
}

// Sort options
export enum TransactionSortOption {
  TRANSACTION_ID = 'transaction-id',
  TYPE = 'type',
  DATE = 'date',
  CREATED_AT = 'created-at',
  FROM_LOCATION = 'from-location',
  TO_LOCATION = 'to-location',
}
